export default __webpack_public_path__ + "static/media/powerchina-logo.653f8486.png";